import primitives from './primitives';
var fill = {
  interactive: {
    light: {
      fillIntActive: primitives.digiBlue[5],
      fillIntHighlighted: primitives.digiBlue[3],
      fillIntSubHover: primitives.neutral[1],
      fillIntSubActive: primitives.neutral[2],
      fillIntDisabled: primitives.neutral[3]
    },
    dark: {
      fillIntActive: primitives.digiBlue[5],
      fillIntHighlighted: primitives.digiBlue[3],
      fillIntSubHover: primitives.neutral[1],
      fillIntSubActive: primitives.neutral[2],
      fillIntDisabled: primitives.neutral[3]
    }
  },
  background: {
    light: {
      fillBgWhite: primitives.neutral[0],
      fillBgSub: primitives.neutral[1],
      fillIconBgDefault: primitives.digiBlue[1],
      fillBgBlack: primitives.neutral[10]
    },
    dark: {
      fillBgWhite: primitives.neutral[0],
      fillBgSub: primitives.neutral[1],
      fillIconBgDefault: primitives.digiBlue[1],
      fillBgBlack: primitives.neutral[10]
    }
  },
  highlight: {
    light: {
      fillHighlight1: '#FFF1DD',
      fillHighlight2: '#FBD3D3',
      fillHighlight3: '#F2F8FF',
      fillHighlight4: '#E4FAE2',
      fillHighlight5: '#F8F8F8'
    },
    dark: {
      fillHighlight1: '#FFF1DD',
      fillHighlight2: '#FBD3D3',
      fillHighlight3: '#F2F8FF',
      fillHighlight4: '#E4FAE2',
      fillHighlight5: '#F8F8F8'
    }
  },
  tag: {
    light: {
      successActive: primitives.green[5],
      successBgActive: primitives.green[2],
      successHighlighted: primitives.green[3],
      successSubHover: primitives.neutral[1],
      successSubActive: primitives.neutral[2],
      successDisabled: primitives.neutral[3],
      errorActive: primitives.red[5],
      errorBgActive: primitives.red[1],
      errorBgSubtle: '#FEF2F2',
      errorBorderSubtle: '#FECACA',
      errorHighlighted: primitives.red[3],
      errorSubHover: primitives.neutral[1],
      errorSubActive: primitives.neutral[2],
      errorDisabled: primitives.neutral[3]
    },
    dark: {
      successActive: primitives.green[5],
      successBgActive: primitives.green[2],
      successHighlighted: primitives.green[3],
      successSubHover: primitives.neutral[1],
      successSubActive: primitives.neutral[2],
      successDisabled: primitives.neutral[3],
      errorActive: primitives.red[5],
      errorBgActive: primitives.red[1],
      errorBgSubtle: '#FEF2F2',
      errorBorderSubtle: '#FECACA',
      errorHighlighted: primitives.red[3],
      errorSubHover: primitives.neutral[1],
      errorSubActive: primitives.neutral[2],
      errorDisabled: primitives.neutral[3]
    }
  }
};
var text = {
  interactive: {
    light: {
      textIntWhite: primitives.neutral[0],
      textIntDefault: primitives.neutral[8],
      textIntEmphasized: primitives.neutral[7],
      textIntHighlighted: primitives.digiBlue[6],
      textIntDisabled: primitives.neutral[5],
      textIntSub: primitives.neutral[6],
      textIntSubHover: primitives.neutral[7],
      textIntSubActive: primitives.neutral[8]
    },
    dark: {
      textIntWhite: primitives.neutral[5],
      textIntDefault: primitives.neutral[8],
      textIntEmphasized: primitives.neutral[7],
      textIntHighlighted: primitives.digiBlue[6],
      textIntDisabled: primitives.neutral[5],
      textIntSub: primitives.neutral[6],
      textIntSubHover: primitives.neutral[7],
      textIntSubActive: primitives.neutral[8]
    }
  },
  content: {
    light: {
      contentWhite: primitives.neutral[0],
      contentMinimum: primitives.neutral[5],
      contentBody: primitives.neutral[7],
      contentTitle: primitives.neutral[8],
      contentHeading: primitives.neutral[9],
      contentHighlighted: primitives.digiBlue[6]
    },
    dark: {
      contentHighlighted: primitives.digiBlue[6],
      contentHeading: primitives.neutral[9],
      contentTitle: primitives.neutral[8],
      contentBody: primitives.neutral[7],
      contentMinimum: primitives.neutral[5],
      contentWhite: primitives.neutral[0]
    }
  }
};
var shapesIcons = {
  light: {
    shapeHighlighted: primitives.digiBlue[6],
    shapeDefault: primitives.neutral[9],
    shapeEmphasized: primitives.neutral[6],
    shapeWhite: primitives.neutral[0],
    shapeBorder: '#CBD5E1'
  },
  dark: {
    shapeHighlighted: primitives.digiBlue[6],
    shapeDefault: primitives.neutral[9],
    shapeEmphasized: primitives.neutral[6],
    shapeWhite: primitives.neutral[0],
    shapeBorder: '#CBD5E1'
  }
};
export default {
  fill: fill,
  text: text,
  shapesIcons: shapesIcons
};